import { render, staticRenderFns } from "./CorporationI.vue?vue&type=template&id=3f94dadc&scoped=true"
import script from "./CorporationI.vue?vue&type=script&lang=js"
export * from "./CorporationI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f94dadc",
  null
  
)

export default component.exports